<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: '2xl',
  },
  closeable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['close']);

watch(
  () => props.show,
  () => {
    if (props.show) {
      //   document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
      document.body.classList.add('overflow-hidden');
    } else {
      //   document.body.style.overflow = null;
      document.body.classList.remove('modal-open');
      document.body.classList.remove('overflow-hidden');
    }
  }
);

const close = () => {
  if (props.closeable) {
    emit('close');
  }
};

const closeOnEscape = e => {
  if (e.key === 'Escape' && props.show) {
    close();
  }
};

onMounted(() => document.addEventListener('keydown', closeOnEscape));

onUnmounted(() => {
  document.removeEventListener('keydown', closeOnEscape);
  //   document.body.style.overflow = null;
  document.body.classList.remove('modal-open');
  document.body.classList.remove('overflow-hidden');
});

const maxWidthClass = computed(() => {
  return {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    '4xl': 'sm:max-w-4xl',
  }[props.maxWidth];
});
</script>

<template>
  <teleport to="body">
    <transition leave-active-class="duration-200">
      <div
        v-show="show"
        scroll-region
        class="fixed w-full pt-4 h-screen bottom-0 sm:inset-0 overflow-y-auto sm:px-4 sm:py-6 sm:mb-12 z-50"
        :class="$settings.modal_position == 'center' ? 'sm:flex sm:items-center sm:justify-center' : ''"
      >
        <div :class="maxWidthClass" class="mt-auto mb-0 sm:my-auto sm:mx-auto w-full">
          <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div v-show="show" class="fixed inset-0 transform transition-all" @click="close">
              <div class="absolute inset-0 bg-gray-500 opacity-75" />
            </div>
          </transition>

          <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-show="show"
              class="bg-white w-full rounded-t-lg sm:rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:mx-auto"
              :class="$settings.modal_position == 'center' ? maxWidthClass + ' my-auto' : maxWidthClass"
            >
              <slot v-if="show" />
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </teleport>
</template>
